import { render, staticRenderFns } from "./TeamAnswers.vue?vue&type=template&id=49e169d4&scoped=true&"
import script from "./TeamAnswers.vue?vue&type=script&lang=js&"
export * from "./TeamAnswers.vue?vue&type=script&lang=js&"
import style0 from "./TeamAnswers.vue?vue&type=style&index=0&id=49e169d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e169d4",
  null
  
)

export default component.exports